<template>
  <div>
    <b-container class="home-container text-left">
      <b-row class="greenH">
        <b-col class="m-5 pb-2">
          <h1 class="mb-lg-4 greenH pb-3">Demján Sándor 1+1 KKV Beruházás-élénkítő Támogatási Program 2. Ütem</h1>
          <p class="greenH bevezeto">
            A Nemzetgazdasági Minisztérium az 1. ütem sikerére építve 2025. november 6-án elindította a Demján Sándor
            1+1 KKV Beruházás-élénkítő Támogatási Program 2. ütemére az érdeklődő cégek regisztrációját, majd 2025.
            november 20-án a támogatási kérelmek benyújtásához szükséges előzetes adattöltést. Fontos, hogy az előzetes
            adattöltést csak azon cégek tudják elindítani, akik előzetesen részt vettek a pályázati regisztrációban.
            <br />
          </p>
          <p class="greenH bevezeto">
            A program elsődleges célja, hogy a hazai tulajdonú, mikro-, kis- és középvállalkozások beruházási aktivitása
            emelkedjen, a termelési kapacitásuk fejlődjön, és magasabb hozzáadott értékű termékek gyártása kezdődjön meg
            a magyar gazdaságban.
          </p>
          <p class="greenH bevezeto">
            Felhívjuk a figyelmüket, hogy a Demján Sándor Tőkeprogram által elérhető forrás is felhasználható a Demján
            Sándor 1+1 KKV Beruházás-élénkítő Támogatási Programban előírt önerő biztosítására, megkönnyítve a
            vállalkozások fejlesztési terveinek megvalósítását. Az önerő külső forrásból történő biztosítására tehát már
            tőkeági finanszírozás is rendelkezésre áll a hitelek mellett. További információ:
            <a href="https://demjantokeprogram.hu" target="_blank" class="white-link">
              https://demjantokeprogram.hu
            </a>
          </p>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="wrapper text-left">
      <b-row class="box-top p-5 mb-md-5">
        <b-col class="B pb-2" cols="12" lg="5">Pályázók köre</b-col>
        <b-col class="pb-2" cols="12" lg="7">mikro-, kis- és középvállalkozások</b-col>
        <b-col class="B pb-2" cols="12" lg="5">Meghirdetés dátuma</b-col>
        <b-col class="pb-2" cols="12" lg="7">2025.11.19.</b-col>
        <b-col class="B pb-2" cols="12" lg="5">Igényelhető támogatás</b-col>
        <b-col class="pb-2" cols="12" lg="7">25.000.000 - 200.000.000 Ft</b-col>
        <b-col class="B pb-2" cols="12" lg="5">Támogatható tevékenységek</b-col>
        <b-col class="pb-2" cols="12" lg="7">Technológiai fejlesztést eredményező új eszközök beszerzése</b-col>
        <b-col class="B pb-2" cols="12" lg="5">Keretösszeg</b-col>
        <b-col class="pb-2" cols="12" lg="7">20.000.000.000 Ft</b-col>
        <b-col class="B pb-2" cols="12" lg="5">Projekt megvalósításának határideje</b-col>
        <b-col class="pb-2" cols="12" lg="7">12 hónap, mely indokolt esetben 6 hónappal meghosszabbítható</b-col>
        <b-col class="B pb-2" cols="12" lg="5">Előzetes adattöltés</b-col>
        <b-col class="pb-2" cols="12" lg="7">2025.11.20. 10:00 - 2025.11.28. 12:00</b-col>
        <b-col class="B pb-2" cols="12" lg="5">Benyújtási időszak kezdete</b-col>
        <b-col class="pb-2" cols="12" lg="7">2025.12.01. 10:00</b-col>
        <b-col class="B pb-2" cols="12" lg="5">Értékelési szempontrendszer</b-col>
        <b-col class="pb-2" cols="12" lg="7">
          Előre meghatározott, pénzügyi és szakmai értékelési kritériumok alapján, pontszám szerinti sorendbe állítással
        </b-col>
      </b-row>
    </b-container>
    <b-container class="desktopdot text-left">
      <b-row class="mb-3 mt-3">
        <b-col cols="12" class="text-center">
          <h1>Pályázás ütemezése</h1>
        </b-col>
        <b-col>
          <h3>2. ütem</h3>
          <hr class="mb-5" />
          <div class="progress-line mt-5">
            <span class="dot">1</span>
            <span class="dot">2</span>
            <span class="dot">3</span>
            <span class="dot">4</span>
            <span class="dot">5</span>
            <span class="dot">6</span>
          </div>
          <b-row class="mt-5 text-center B">
            <b-col v-for="(item, index) in accordionItems" :key="index" sm="12" md="2">
              <b-card-header header-tag="headerv" class="p-0" role="tab">
                <button
                  v-b-toggle="accordionState[index] ? 'accordion-' + index : false"
                  size="sm"
                  class="buttonScrolling"
                  @click="toggleAccordion(index)"
                >
                  {{ item.title }}
                  <br />
                  <span class="when-opened">
                    <ChevronRightIcon :size="25" />
                  </span>
                  <span class="when-closed">
                    <ChevronDownIcon :size="25" />
                  </span>
                </button>
              </b-card-header>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <div v-for="(item, index) in accordionItems" :key="index">
          <div v-if="accordionState[index]" class="full-width-info" :style="item.pozition">
            <b-row class="blockBox">
              <competition-small-details :competition="offer" />
              <p class="mr-5 ml-5" v-for="(desc, index) in item.description" :key="index">{{ desc }}</p>
            </b-row>
          </div>
        </div>
      </b-row>
    </b-container>
    <b-container class="mobildot text-left">
      <b-row>
        <b-col cols="12" class="text-center">
          <h1>Pályázás ütemezése</h1>
        </b-col>
        <b-col>
          <h3>1. szakasz</h3>
          <hr class="mb-5" />
          <b-row class="mt-5 text-center">
            <b-col v-for="(item, index) in accordionItems" :key="index" sm="12">
              <b-row class="mobilblockBox">
                <h5 class="B ml-4">{{ item.title }}</h5>
                <competition-small-details :competition="offer" />
                <p class="mr-4 ml-4" v-for="(desc, index) in item.description" :key="index">{{ desc }}</p>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row class="mt-5 pt-5 mb-4">
        <b-button class="bigButon" @click="openLink('https://egypluszegy2.vali.hu/kau-login')" target="_blank">
          <h2 class="greenH">
            <span class="left-span">Tovább a pályázói felületre</span>
            <ChevronRightIcon :size="45" />
          </h2>
        </b-button>
      </b-row>
    </b-container>
    <b-container class="desktopdot mb-3">
      <!-- Dokumentumok, Segédletek, Nyilatkozatok - Egy elem nyílhat le egyszerre -->
      <b-row>
        <b-col>
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="box-Role">
              <button v-b-toggle="'accordion-8'" class="buttonScroll buttonRight">
                <button @click="toggleIsActive" class="buttonScroll buttonRight">
                  <span class="B left-span">Pályázati dokumentumok</span>
                  <span :style="{ transform: isActive ? 'rotate(90deg)' : 'rotate(0deg)' }">
                    <ChevronRightIcon :size="45" />
                  </span>
                </button>
              </button>
            </b-card-header>
            <b-col class="Box_padding" cols="12" lg="12">
              <b-collapse id="accordion-8">
                <div class="mt-2">
                  <b-row>
                    <b-col class="Box_padding" v-for="(item, index) in accordionItemsSecond" :key="index">
                      <b-card-header header-tag="headerv" class="box-RoleDow">
                        <button v-b-toggle="'accordion-' + index" class="buttonScroll" @click="toggleAccordion(index)">
                          <span>{{ item.title }}</span>
                        </button>
                      </b-card-header>
                    </b-col>
                  </b-row>
                </div>
              </b-collapse>
            </b-col>
          </b-row>
          <b-row class="seconds" :class="{ active: isActive }">
            <b-col cols="12" v-for="(item, index) in accordionItemsSecond" :key="index">
              <div v-if="accordionStateSecond[index]" class="full-width-info-download">
                <competition-small-details :competition="offer" />
                <div class="download">
                  <ul class="p-1">
                    <li v-for="(doc, idx) in item.documents" :key="idx">
                      <a class="services-button-wrapper" download target="_blank" :href="doc.url">
                        {{ doc.text }}
                        <img src="../assets/img/icons/download.svg" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="mobildot">
      <!-- Dokumentumok, Segédletek, Nyilatkozatok - Egy elem nyílhat le egyszerre -->
      <b-row>
        <b-col>
          <b-row>
            <b-col class="buttonRight mt-4 mb-3">
              <span class="B left-span">Pályázati dokumentumok</span>
            </b-col>
            <b-col class="Box_padding" cols="12" lg="12">
              <div class="mt-2">
                <b-row>
                  <b-col class="Box_padding" v-for="(item, index) in accordionItemsSecond" :key="index" sm="12">
                    <span class="BoxTitle">{{ item.title }}</span>
                    <!-- Letöltési lista -->
                    <div class="download">
                      <ul class="p-1">
                        <li v-for="(doc, idx) in item.documents" :key="idx">
                          <a class="services-button-wrapper" :href="doc.url" download target="_blank">
                            {{ doc.text }}
                            <img src="../assets/img/icons/download.svg" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row>
        <b-col class="mb-4">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="box-Role">
              <button
                @click="openLink('https://vali.hu/static/DS_1+1_II_utem_kiadott_TOk_20260907.pdf')"
                download
                class="buttonScroll buttonRight"
              >
                <span class="B left-span">Támogatott vállalkozások</span>
                <img src="../assets/img/icons/download.svg" class="modositas_icon" />
              </button>
            </b-card-header>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="mt-5">
      <h2 class="font-weight-bold mb-2 mt-5">
        Ügyfélszolgálat elérhetősége
      </h2>
      <b-row>
        <b-col class="Box_padding" cols="12" lg="6">
          <div class="text-left">
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-4">
                <p class="greenText pt-3 mb-3">Ügyfélszolgálat várja megkeresését az alábbi munkarendben:</p>
                <p class="mb-2">Hétfőtől csütörtökig: 8:00 – 17:00</p>
                <p>Pénteken: 8:00 – 14:30</p>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col class="Box_padding" cols="12" lg="6">
          <div class="text-left">
            <b-row class="pt-1">
              <b-col class="ml-4 wrapper p-4">
                <p class="greenText pt-3 mb-3">Ügyfélszolgálat elérhetősége:</p>
                <p class="mb-2"><img class="mr-2" src="../assets/img/icons/homephone.svg" /> +36 1 312 2213</p>
                <p>
                  <img class="mr-2" src="../assets/img/icons/envelope.svg" />
                  <a href="mailto:info@mgfu.hu">
                    info@mgfu.hu
                  </a>
                </p>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <!-- <b-modal id="simple-popup" size="lg" centered>
      <div class="notification-content">
        <p>
          A támogatási kérelemhez <strong>minősített elektronikus aláírással (QES)</strong> ellátott nyilatkozatok
          feltöltése szükséges. Amennyiben a pályázó vállalkozás a támogatási kérelem benyújtásáig nem rendelkezik
          minősített elektronikus aláírás kiállításhoz szükséges tanúsítvánnyal, kérjük, cégszerűen aláírt és
          felszkennelt pdf dokumentumként csatolja a nyilatkozatokat, és a tanúsítvány beszerzésének elindítását igazoló
          dokumentumot.
        </p>
        <p>
          Tájékoztatjuk a pályázó vállalkozásokat, hogy a minősített elektronikus aláírással ellátott nyilatkozatok
          <strong>hiánypótlás keretében pótolhatók.</strong>
        </p>
      </div>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('simple-popup')">Bezárás</b-button>
      </template>
    </b-modal> -->
    <b-container class="dspbody">
      <b-row class="mb-5 body">
        <!-- Kép -->
        <b-col cols="12" lg="12" class="dspBox_padding">
          <img src="../assets/img/Demjan.jpg" style="max-width: 100%;" />
        </b-col>
        <!-- DEMJÁN SÁNDOR TŐKEPROGRAM -->
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
              <button v-b-toggle="'accordion-9'" class="dspbuttonScroll">
                <b-col cols="12" lg="10"><span class="dspname">DEMJÁN SÁNDOR</span> TŐKEPROGRAM</b-col>
                <span v-if="!isOpenAccordion9">
                  <ChevronRightIcon :size="30" />
                </span>
                <span v-if="isOpenAccordion9">
                  <ChevronDownIcon :size="30" />
                </span>
              </button>
            </b-card-header>
          </b-row>
          <b-row>
            <b-collapse id="accordion-9" v-model="isOpenAccordion9">
              <div class="offer-description mt-2">
                <b-row class="dspblockBox">
                  <b-col class="m-2">
                    <competition-small-details :competition="offer" />
                    <p>
                      A vállalkozások komolyabb mértékű, méretugrásukat támogató fejlesztéseinek speciális támogatása
                      keretében az állam 1%-os, jelképes tulajdonrész szerzése mellett biztosít 6 éves időtartamra
                      olcsó, nagyösszegű fejlesztési forrást alárendelt kölcsöntőke juttatás keretében.
                    </p>
                    <p>
                      A lehetőség iparági megkötöttség és széles körű beruházási célra biztosít viszonylag nagy összegű,
                      100-200 millió forintos friss forrást évi 5%-os kamatozás mellett. A tőkefinanszírozás révén a
                      vállalkozás hitelképessége javul.
                    </p>
                    <button class="dsplink" @click="openLink('https://mkik.hu/tokeprogram')" target="_blank">
                      Tovább a programra
                    </button>
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </b-row>
        </b-col>
        <!-- DEMJÁN SÁNDOR 1+1 BERUHÁZÁS-ÉLÉNKÍTŐ TÁMOGATÁSI PROGRAM -->
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
              <button v-b-toggle="'accordion-10'" class="dspbuttonScroll">
                <b-col cols="12" lg="10">
                  <span class="dspname">DEMJÁN SÁNDOR</span> „1+1” KKV BERUHÁZÁS-ÉLÉNKÍTŐ TÁMOGATÁSI PROGRAM
                </b-col>
                <span v-if="!isOpenAccordion10">
                  <ChevronRightIcon :size="30" />
                </span>
                <span v-if="isOpenAccordion10">
                  <ChevronDownIcon :size="30" />
                </span>
              </button>
            </b-card-header>
          </b-row>
          <b-row>
            <b-collapse id="accordion-10" v-model="isOpenAccordion10">
              <div class="offer-description mt-2">
                <b-row class="dspblockBox">
                  <b-col class="m-2">
                    <competition-small-details :competition="offer" />
                    <p>
                      A program a hazai tulajdonú, mikro-, kis- és középvállalkozások eszközberuházásait támogatja annak
                      érdekében, hogy termelési kapacitásuk fejlődjön, valamint magasabb hozzáadott értékű termékek
                      gyártására nyíljon lehetőségük. Egy vállalkozás maximum 200 millió forint támogatásban
                      részesülhet. A vállalkozás beruházásának 50%-át az állam vissza nem térítendő támogatásként
                      biztosítja. A vissza nem térítendő támogatásra vonatkozó program két ütemben valósul meg.
                    </p>
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </b-row>
        </b-col>
        <!-- DEMJÁN SÁNDOR MINDEN VÁLLALKOZÁSNAK LEGYEN SAJÁT HONLAPJA PROGRAM -->
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
              <button v-b-toggle="'accordion-11'" class="dspbuttonScroll">
                <b-col cols="12" lg="10">
                  <span class="dspname">DEMJÁN SÁNDOR</span> „MINDEN VÁLLALKOZÁSNAK LEGYEN SAJÁT HONLAPJA” PROGRAM
                </b-col>
                <span v-if="!isOpenAccordion11">
                  <ChevronRightIcon :size="30" />
                </span>
                <span v-if="isOpenAccordion11">
                  <ChevronDownIcon :size="30" />
                </span>
              </button>
            </b-card-header>
          </b-row>
          <b-row>
            <b-collapse id="accordion-11" v-model="isOpenAccordion11">
              <div class="offer-description mt-2">
                <b-row class="dspblockBox">
                  <b-col class="m-2">
                    <competition-small-details :competition="offer" />
                    <p>
                      A program célja csökkenteni a hazai kkv-k digitalizációs elmaradását az uniós versenytársakhoz
                      képest – hazánkban a 10 fő feletti vállalkozások kétharmada rendelkezik saját honlappal, az EU
                      közel 80%-os átlagához képest – aki ma nincs jelen az interneten, vagy a social média felületein,
                      sokkal kisebb eséllyel talál magának ügyfelet.
                    </p>
                    <p>
                      A program keretében a kormány két éves időtartamra átvállalja az internetes megjelenés
                      támogatásához szükséges digitális eszközök (webcím, tárhely, email) szolgáltatói költségeit,
                      támogatást nyújt a weboldal és a social média felületek arculati és tartalomfejlesztéshez, a
                      kibervédelmi, illetve az internetes értékesítést támogató szolgáltatások igénybevételéhez.
                    </p>
                    <button class="dsplink" @click="openLink('https://palyazat.neum.hu')" target="_blank">
                      Tovább a programra
                    </button>
                    <!-- <h5>Részletek hamarosan!</h5> -->
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </b-row>
        </b-col>
        <!-- DEMJÁN SÁNDOR SZÉCHENYI KÁRTYA PROGRAM -->
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
              <button v-b-toggle="'accordion-12'" class="dspbuttonScroll">
                <b-col cols="12" lg="10">
                  <span class="dspname">DEMJÁN SÁNDOR</span> KEDVEZMÉNYES (3,0%) SZECHENYI KÁRTYA
                </b-col>
                <span v-if="!isOpenAccordion12">
                  <ChevronRightIcon :size="30" />
                </span>
                <span v-if="isOpenAccordion12">
                  <ChevronDownIcon :size="30" />
                </span>
              </button>
            </b-card-header>
          </b-row>
          <b-row>
            <b-collapse id="accordion-12" v-model="isOpenAccordion12">
              <div class="offer-description mt-2">
                <b-row class="dspblockBox">
                  <b-col class="m-2">
                    <competition-small-details :competition="offer" />
                    <p>
                      A beruházások ösztönzése érdekében november 1-től 5 százalékról 3,0 százalékra csökken az ügyfelek
                      által fizetendő éves kamat a Széchenyi Kártya program beruházást támogató hitelelemeinél:
                    </p>
                    <ul>
                      <li>Széchenyi Beruházási Hitel MAX+,</li>
                      <li>Széchenyi Lízing MAX+,</li>
                      <li>Széchenyi Mikrohitel MAX+,</li>
                      <li>Agrár Széchenyi Beruházási Hitel MAX+.</li>
                    </ul>
                    <p>
                      A még kedvezményesebb kamatozás mellet a 2025. június 30-ig Széchenyi Kártya beruházási
                      hiteltermékeit igénylő vállalkozások számára az első évben díjmentesen nyújtja a hitelhez
                      kötelezően kapcsolt kezesség kezességvállalását a Garantiqa Hitelgarancia Zrt.
                    </p>
                    <button class="dsplink" @click="openLink('https://www.kavosz.hu')" target="_blank">
                      Tovább a programra
                    </button>
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </b-row>
        </b-col>
        <!-- DEMJÁN SÁNDOR EXPORTÖSZTÖNZŐ HITELPROGRAM -->
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
              <button v-b-toggle="'accordion-13'" class="dspbuttonScroll">
                <b-col cols="12" lg="10"><span class="dspname">DEMJÁN SÁNDOR</span> EXPORTÖSZTÖNZŐ HITELPROGRAM</b-col>
                <span v-if="!isOpenAccordion13">
                  <ChevronRightIcon :size="30" />
                </span>
                <span v-if="isOpenAccordion13">
                  <ChevronDownIcon :size="30" />
                </span>
              </button>
            </b-card-header>
          </b-row>
          <b-row>
            <b-collapse id="accordion-13" v-model="isOpenAccordion13">
              <div class="offer-description mt-2">
                <b-row class="dspblockBox">
                  <b-col class="m-2">
                    <competition-small-details :competition="offer" />
                    <p>
                      A Demján Sándor Program keretében az EXIM újraindítja korábbi nagysikerű termékeit, amelyeket
                      exportáló és nem exportáló vállalkozások is igénybe vehetnek beruházási, zöld beruházási és lízing
                      célokra.
                    </p>
                    <ul>
                      <span>Termékek:</span>
                      <li>EXIM Jövő Exportőrei Beruházási és Zöld Beruházási Hitel</li>
                      <li>EXIM Exportélénkítő Beruházási Hitel és Lízing</li>
                    </ul>
                    <button class="dsplink" @click="openLink('https://exim.hu/demjan-sandor-program/')" target="_blank">
                      Tovább a programra
                    </button>
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </b-row>
        </b-col>
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
              <button v-b-toggle="'accordion-14'" class="dspbuttonScroll">
                <b-col cols="12" lg="10">
                  <span class="dspname">DEMJÁN SÁNDOR</span> KIFEKTETÉST TÁMOGATÓ HITEL- ÉS TŐKEPROGRAM
                </b-col>
                <span v-if="!isOpenAccordion14">
                  <ChevronRightIcon :size="30" />
                </span>
                <span v-if="isOpenAccordion14">
                  <ChevronDownIcon :size="30" />
                </span>
              </button>
            </b-card-header>
          </b-row>
          <b-row>
            <b-collapse id="accordion-14" v-model="isOpenAccordion14">
              <div class="offer-description mt-2">
                <b-row class="dspblockBox">
                  <b-col class="m-2">
                    <competition-small-details :competition="offer" />
                    <p>
                      A program keretében külpiaci beruházások, cégalapítások, cégfelvásárlások (kifektetés)
                      támogathatóak, amelyek új piacok szerzésével, terjeszkedéssel segítik a vállalkozások
                      versenyképességének növelését, a cég növekedési pályára állását, a bevételi források és kockázatok
                      diverzifikációját. Nem titkolt cél magyar multik, nemzeti bajnok vállalkozások kinevelése.
                    </p>
                    <p>
                      EXIM Kifektetési Hitel:
                      <button
                        class="dsplink"
                        @click="openLink('https://exim.hu/demjan-sandor-program/')"
                        target="_blank"
                      >
                        Tovább a programra
                      </button>
                    </p>
                    <p>
                      Tőkebefektetés a határokon átívelő beruházásokért:
                      <button
                        class="dsplink"
                        @click="openLink('https://focusventures.hu/nemzetkozi-lehetosegek')"
                        target="_blank"
                      >
                        Tovább a programra
                      </button>
                    </p>
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </b-row>
        </b-col>
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
              <button v-b-toggle="'accordion-15'" class="dspbuttonScroll">
                <b-col cols="12" lg="10"><span class="dspname">DEMJÁN SÁNDOR</span> UNIÓS TÁMOGATÁSI PROGRAMOK</b-col>
                <span v-if="!isOpenAccordion15">
                  <ChevronRightIcon :size="30" />
                </span>
                <span v-if="isOpenAccordion15">
                  <ChevronDownIcon :size="30" />
                </span>
              </button>
            </b-card-header>
          </b-row>
          <b-row>
            <b-collapse id="accordion-15" v-model="isOpenAccordion15">
              <div class="offer-description mt-2">
                <b-row class="dspblockBox">
                  <b-col class="m-2">
                    <competition-small-details :competition="offer" />
                    <p>
                      A magyarországi kkv-szektor számára 2025-ben 650 milliárd forintnyi uniós forrás kihelyezésére
                      nyílik lehetőség vissza nem térítendő támogatás, támogatott hitel, illetve ezek kombinációja
                      révén.
                    </p>
                    <!--button class="dsplink" @click="openLink('www.palyazat.gov.hu')" target="_blank">
                      Tovább a programra
                    </button-->
                    <h5>Részletek hamarosan!</h5>
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </b-row>
        </b-col>
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
              <button v-b-toggle="'accordion-16'" class="dspbuttonScroll">
                <b-col cols="12" lg="10">
                  <span class="dspname">DEMJÁN SÁNDOR</span> KKV ADMINISZTRÁCIÓS TERHEINEK CSÖKKENTÉSE
                </b-col>
                <span v-if="!isOpenAccordion16">
                  <ChevronRightIcon :size="30" />
                </span>
                <span v-if="isOpenAccordion16">
                  <ChevronDownIcon :size="30" />
                </span>
              </button>
            </b-card-header>
          </b-row>
          <b-row>
            <b-collapse id="accordion-16" v-model="isOpenAccordion16">
              <div class="offer-description mt-2">
                <b-row class="dspblockBox">
                  <b-col class="m-2">
                    <competition-small-details :competition="offer" />
                    <p>
                      A Nemzetgazdasági Minisztérium a vállalkozói szakmai és érdekképviseleti szervezetekkel
                      országszerte és folyamatosan konzultálva felmérjük és összegyűjtjük a KKV-k javaslatait és
                      igényeit az őket terhelő adminisztráció csökkentésére, és működési környezetük egyszerűsítésére
                      vonatkozóan.
                    </p>
                    <p>
                      Az adminisztrációcsökkentés kiemelt fókuszterületei:
                    </p>
                    <ul>
                      <li>adatszolgáltatás</li>
                      <li>jogszabályi környezet</li>
                      <li>adózási adminisztráció</li>
                    </ul>
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </b-row>
        </b-col>
        <b-col style="text-align:justify" cols="12" lg="12">
          <b-row>
            <b-card-header header-tag="headerv" role="tab" class="dspbox-Role mr-3">
              <button v-b-toggle="'accordion-17'" class="dspbuttonScroll">
                <b-col cols="12" lg="10">
                  <span class="dspname">DEMJÁN SÁNDOR</span> MIKROVÁLLALKOZÁSOK ÁRAMÁRAINAK CSÖKKENTÉSE
                </b-col>
                <span v-if="!isOpenAccordion17">
                  <ChevronRightIcon :size="30" />
                </span>
                <span v-if="isOpenAccordion17">
                  <ChevronDownIcon :size="30" />
                </span>
              </button>
            </b-card-header>
          </b-row>
          <b-row>
            <b-collapse id="accordion-17" v-model="isOpenAccordion17">
              <div class="offer-description mt-2">
                <b-row class="dspblockBox">
                  <b-col class="m-2">
                    <competition-small-details :competition="offer" />
                    <h4>Mikrovállalkozások áramárainak csökkentése</h4>
                    <p>
                      2025. január 1-jétől újabb mikrovállalkozások válnak jogosulttá a villamos energia egyetemes
                      szolgáltatás igénybevételére, akik 2022. június 18-án nem egyetemes szolgáltatótól vételeztek,
                      vagy ezen dátumot követően alakultak meg. Ennek köszönhetően számos további mikrovállalkozás
                      kaphatja az áramot az olcsóbb, rezsicsökkentett, azaz a nem lakossági egyetemes szolgáltatás
                      árképzésének megfelelő áron, a 4 606 kWh éves fogyasztásig.
                    </p>
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'
export default {
  name: 'egypluszegy',
  components: {
    ChevronDownIcon,
    ChevronRightIcon
  },
  mounted() {
    this.showModal() // Automatikus megjelenítés oldal betöltéskor
  },
  data() {
    return {
      accordionState: {}, // Tárolja az egyes elemek kinyitottságát
      //1. szakasz kis lennyiló szövegek
      accordionItems: [
        {
          title: 'Pályázati koncepció megjelenése, pályázati regisztráció',
          description: [
            'Pályázati koncepció megjelenése, pályázati regisztráció: A 2025. november 5-én megjelent pályázati koncepció alapján 2025. november 6 és november 12 között a vállalkozások részére nyitva a pályázat regisztrációja. A regisztráció a Támogató erre a célra létrehozott pályázati felületén történik (https://egypluszegy2.vali.hu/). A pályázati regisztráció nem jelenti a támogatási kérelem benyújtását.'
          ],
          pozition: 'left: 0'
        },
        {
          title: 'Pályázati felhívás megjelenése',
          description: [
            'Pályázati felhívás megjelenése: A pályázati felhívás 2025. november 19-től elérhető és letölthető ezen a felületen.'
          ],
          pozition: 'left: 5%'
        },
        {
          title: 'Előzetes adattöltés',
          description: [
            'Előzetes adattöltés: A támogatási kérelem előzetes adattöltésre 2025. november 20. 10 órától 2025. november 28.  12.00-ig van lehetőség. Az előtöltési folyamat során a Pályázó véglegesíti támogatási kérelmét, illetve elmentheti amennyiben minden adatmező kitöltésre kerül.'
          ],
          pozition: 'left: 14%'
        },
        {
          title: 'Támogatási kérelmek benyújtása',
          description: [
            'Támogatási kérelmek benyújtása:  A támogatási kérelem benyújtása előzetes regisztrációhoz kötött. A pályázati regisztráció, illetve az előzetes adatrögzítés elvégzése nem jelenti a támogatási kérelem benyújtását. A teljeskörűen feltöltött támogatási kérelmek a sikeres regisztráció és a felhívás 3. pontja szerinti kritériumok megállapítását követően nyújthatók be. A támogatási kérelmek benyújtására 2025. december 1-jén 10:00-tól 14:00 óráig van lehetőség.'
          ],
          pozition: 'left: 28%'
        },
        {
          title: 'Támogatási kérelem ellenőrzése, értékelése',
          description: [
            'Támogatási kérelem ellenőrzése, értékelése: A benyújtott Támogatási kérelmeket a Támogató jogosultsági és tartalmi szempontból ellenőrzi. Amennyiben a támogatási kérelem a felhívásban foglaltaknak megfelelően került beküldésre, az értékelési szakaszba lép a pályázat. Amennyiben a támogatási kérelem hiányos vagy hibás és ezért nem felel meg a támogatási feltételeknek, a Támogató – a felhívásban foglaltaknak megfelelően – 1 alkalommal hiánypótlás keretében ad lehetőséget korrekcióra a támogatást igénylő vállalkozásnak. Amennyiben a beküldött támogatási kérelem vizsgálata során jogosultsági, vagy tartalmi hiányosságok kerülnek megállapításra, Támogató dönthet a kérelem elutasításáról.'
          ],
          pozition: 'left: 40%'
        },
        {
          title: 'Támogatói döntés',
          description: [
            'Támogatói döntés: A támogatási kérelem elfogadása esetén a Támogató a pozitív támogatói döntésről értesíti a Kedvezményezettet. Amennyiben a támogatási kérelem nem kerül elfogadásra, a Támogató a támogatási kérelem elutasításáról értesíti a támogatást igénylő vállalkozást.'
          ],
          pozition: 'left: 40%'
        }
      ],
      //Pályázati dokumentumok
      accordionItemsSecond: [
        {
          title: 'Dokumentumok',
          documents: [
            {
              text: 'Pályázati felhívás',
              url: 'https://vali.hu/static/Felhivas_DemjanSandor_1+1_2.0_251119.pdf'
            },
            {
              text: 'Felhatalmazó levél',
              url: 'https://vali.hu/static/4_sz_felhatalmazo_level.pdf'
            },
            {
              text: 'VTSZ lista',
              url: 'https://vali.hu/static/1_sz_melleklet_VTSZ_lista.pdf'
            },
            {
              text: 'Adatkezelési tájékoztató',
              url: 'https://vali.hu/static/Adatkezelesi_tajekoztato_DS_1+1_2.0.pdf'
            },
            {
              text: 'GYIK',
              url: 'https://vali.hu/static/1+1_GYIK_BERUHAZAS_ELENKITO_2utem_2026jan8.pdf'
            },
            {
              text: 'Meghatalmazás',
              url: 'https://vali.hu/static/Meghatalmazas_2_utem.pdf'
            }
          ],
          hidden: true
        },
        {
          title: 'Nyilatkozatok',
          documents: [
            {
              text: 'Nyilatkozat támogatási kérelemhez',
              url: 'https://vali.hu/static/1+1_2.0_nyilatkozat_tamogatasi_kerelemhez.pdf'
            },
            {
              text: 'Jogi személy nyilatkozata',
              url: 'https://vali.hu/static/2_sz_melleklet_jogi_szemely_nyilatkozata.pdf'
            },
            {
              text: 'Bankszámlaszámokról szóló nyilatkozat',
              url: 'https://vali.hu/static/3_sz_bankszamlaszamokrol_szolo_nyilatkozat.pdf'
            },
            {
              text: 'Átláthatósági nyilatkozat',
              url: 'https://vali.hu/static/5_sz_atlathatosagi_nyilatkozat.pdf'
            },
            {
              text: 'Összeférhetetlenségi nyilatkozat',
              url: 'https://vali.hu/static/7_sz_Nyilatkozat_az_osszeferhetetlenseg_fennallasarol_vagy_hianyarol.xlsx'
            },
            {
              text: 'Tulajdonosi hozzájáruló nyilatkozat',
              url: 'https://vali.hu/static/Tulajdonosi_hozzajarulo_nyilatkozat.pdf'
            }
          ],
          hidden: true
        },
        {
          title: 'Archív dokumentumok',
          documents: [
            /*{
              text: 'Pályázati felhívás 2024.12.05',
              url: 'https://vali.hu/static/egypluszegy-program_Palyazati_Felhivas_20241205.pdf'
            },
            {
              text: 'Pályázati felhívás 2024.12.13',
              url: 'https://vali.hu/static/egypluszegy-program_Palyazati_Felhivas_20241213.pdf'
            },
            {
              text: 'Pályázati felhívás 2024.12.20',
              url: 'https://vali.hu/static/egypluszegy-program_Palyazati_Felhivas_20241220.pdf'
            },
            {
              text: 'Pályázati felhívás 2025.01.10',
              url: 'https://vali.hu/static/egypluszegy-program_Palyazati_Felhivas_20250110.pdf'
            },
            {
              text: 'Pályázati felhívás 2025.01.17',
              url: 'https://vali.hu/static/egypluszegy-program_Palyazati_Felhivas_20250117.pdf'
            },
            {
              text: 'Pályázati felhívás 2025.02.24',
              url: 'https://vali.hu/static/egypluszegy-program_Palyazati_Felhivas_20250224.pdf'
            },
            {
              text: 'Pályázati felhívás 2025.03.26',
              url: 'https://vali.hu/static/egypluszegy-program_Palyazati_Felhivas_20250326.pdf'
            }*/
          ],
          hidden: true
        }
      ],
      accordionStateSecond: [],
      isOpenAccordion9: false,
      isOpenAccordion10: false,
      isOpenAccordion11: false,
      isOpenAccordion12: false,
      isOpenAccordion13: false,
      isOpenAccordion14: false,
      isOpenAccordion15: false,
      isOpenAccordion16: false,
      isOpenAccordion17: false,
      isActive: false
    }
  },
  methods: {
    showModal() {
      this.$bvModal.show('simple-popup')
    },
    toggleIsActive() {
      this.isActive = !this.isActive // Csak az isActive változót váltogatjuk
    },
    toggleAccordion(index) {
      // Ha az aktuális elem már nyitva van, bezárjuk. Ha nem, akkor csak az őt kinyitjuk.
      if (this.accordionState[index]) {
        this.$set(this.accordionState, index, false)
      } else {
        // Az összes többi elemet bezárjuk
        Object.keys(this.accordionState).forEach(key => {
          this.$set(this.accordionState, key, false)
        })
        // Az aktuális elemet kinyitjuk
        this.$set(this.accordionState, index, true)
      }
      if (this.accordionStateSecond[index]) {
        this.$set(this.accordionStateSecond, index, false)
      } else {
        // Az összes többi elemet bezárjuk
        Object.keys(this.accordionStateSecond).forEach(key => {
          this.$set(this.accordionStateSecond, key, false)
        })
        // Az aktuális elemet kinyitjuk
        this.$set(this.accordionStateSecond, index, true)
      }
      this.$set(this.accordionStateSecond, index, !this.accordionStateSecond[index])
      this.accordionStateSecond = this.accordionStateSecond.map((state, i) => (i === index ? !state : false))
    },
    openLink(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.white-link {
  color: white;
  text-decoration: underline;
}

.box-top {
  font-size: large;
}

.box-Role {
  font-size: larger;
  border-radius: 12px;
  border: black;
  width: 100%;
  background-color: #f2f8fa;
}

.b-collapse:not(.show) + .full-width-info-download {
  display: none;
}

.dspspan {
  font-size: larger;
  font-weight: bold;
}

button:focus {
  outline: none;
}

.seconds {
  display: none;
}

.seconds.active {
  display: block;
}

.circle {
  border: #00903c;
  border-radius: 5px;
}

.box-RoleDow {
  font-size: larger;
  border: 0;
  background: transparent;
}

.chevron-icon {
  transition: transform 0.3s ease;
}

.chevron-rotate {
  transform: rotate(90deg); /* Elforgatás 90 fokkal (balra mutató nyíl) */
}

.buttonScroll {
  font-size: larger;
  border-radius: 12px;
  border: black;
  height: 160px;
  width: 100%;
  background-color: #f2f8fa;
}

.DownloadSroll {
  font-size: larger;
  border-radius: 12px;
  border: black;
  height: 160px;
  background-color: #f2f8fa;
}

/* A Download szekció formázása */
.DownloadList {
  background-color: #eaf4e5; /* Világos zöld háttér */
  border-radius: 10px; /* Lekerekített sarkak */
  max-width: 100%;
}

.services-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
}

ul {
  list-style: none;
}

.download li {
  font-weight: 700;
  background: #f2f8fa;
  margin: 10px;
}

.bigButton-1 {
  width: 100%;
  height: 120px;
  background: #00903c !important;
  font-weight: 700;
  line-height: 32px;
  border-radius: 8px;
}

.bigButton-2 {
  width: 100%;
  height: 120px;
  background: #00903c;
  font-weight: 700;
  color: white;
  line-height: 32px;
}

.bigButton-1 h2 {
  display: flex; /* Flexbox elrendezés, hogy egymás mellé kerüljenek az elemek */
  justify-content: space-between; /* A két span egymás mellett, széles területen */
  align-items: center; /* Vertikálisan középre igazítja az elemeket */
  width: 100%; /* Biztosítja, hogy a h2 teljes szélességben elérhető legyen */
  height: 110px;
}

.bigButton-2 h2 {
  display: flex; /* Flexbox elrendezés, hogy egymás mellé kerüljenek az elemek */
  justify-content: space-between; /* A két span egymás mellett, széles területen */
  align-items: center; /* Vertikálisan középre igazítja az elemeket */
  width: 100%; /* Biztosítja, hogy a h2 teljes szélességben elérhető legyen */
}

.buttonRight {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.left-span {
  text-align: center; /* A bal oldali span középre igazítása */
  flex-grow: 1; /* Ezzel biztosítjuk, hogy a bal oldali span középen maradjon */
  font-size: 29px;
}

.B {
  font-weight: bold;
}

.buttontext {
  font-size: 29px;
  font-weight: bold;
}

.bevezeto {
  font-size: larger;
  text-align: justify;
}

.progress-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  height: 15px;
  background-color: #f2f8fa;
  border-radius: 5px; /* A vonal sarkainak lekerekítése */
}

/* Alapértelmezett box szűkítés a képernyőn */
.b-card-header button {
  width: 100%; /* A gomb teljes szélességben */
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  max-width: 100%;
}

.full-width-info {
  position: relative;
  width: 60%;
  background-color: #f9f9f9;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  border-radius: 15px;
  font-size: 18px;
  line-height: 1.6;
}

.full-width-info-download {
  position: relative;
  width: 100%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  border-radius: 15px;
  font-size: 18px;
  line-height: 1.6;
}

.mobildot {
  display: none;
}

.mobilblockBox {
  text-align: justify;
}

.greenTitle {
  color: #00903c;
  text-align: center;
  padding-left: 20px;
}

.Box_padding {
  padding-left: 0 !important;
  padding-right: 19px !important;
}

.dspBox_padding {
  padding-left: 0 !important;
  padding-right: 0 !important;
  background-color: #bee4e3;
}

/* Csak a mobil képernyőkön (max-width: 767px) történő viselkedés */
@media (max-width: 767px) {
  .full-width-info {
    left: 0 !important;
    width: 100% !important;
  }

  .greenH {
    font-size: medium;
  }

  .desktopdot {
    display: none;
  }

  .mobildot {
    display: block;
  }

  .box_popup_div {
    margin-top: 30%;
  }

  .BoxTitle {
    font-size: x-large;
    color: #00903c;
    font-weight: bold;
  }

  .progress-line {
    display: none;
  }

  /* Gombok (nyíl ikonok) méretének optimalizálása mobilra */
  .buttonScrolling {
    font-size: 14px;
  }

  .left-span {
    font-size: 25px;
  }

  .Box_padding {
    padding-left: 10px !important;
  }

  .buttonScroll {
    font-size: larger;
    border-radius: 12px;
    border: black;
    height: 160px;
    width: 100%;
    background-color: #f2f8fa;
  }

  .buttonRight {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .box-Role {
    font-size: larger;
    border-radius: 12px;
    border: black;
    width: 85%;
    margin-left: 25px;
    background-color: #f2f8fa;
  }

  .left-span {
    text-align: center;
    flex-grow: 1; /* Ezzel biztosítjuk, hogy a bal oldali span középen maradjon */
    font-size: 20px;
  }
}

/* Alapértelmezett megjelenés az eseményekhez */
.b-card-header button {
  width: 100%; /* Gombok szélessége legyen 100% */
}

.b-collapse {
  margin-top: 10px;
}

.dot {
  position: absolute;
  width: 30px;
  height: 30px;
  background-color: #00903c; /* Zöld szín */
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  color: white;
  font-weight: bold;
}

.dot:nth-child(1) {
  left: 6%;
}

.dot:nth-child(2) {
  left: 23%;
}

.dot:nth-child(3) {
  left: 40%;
}

.dot:nth-child(4) {
  left: 57%;
}

.dot:nth-child(5) {
  left: 74%;
}

.dot:nth-child(6) {
  left: 94%;
  transform: translateX(-100%); /* A legutolsó pontot a jobb széle alá igazítjuk */
}

.blockBox {
  writing-mode: horizontal-tb !important;
  white-space: normal !important;
  display: block !important;
}

.greenText {
  color: #00903c;
  font-weight: bold;
  font-size: large;
}

.greenH {
  background-color: #00903c;
  color: #fff;
  border-radius: 10px 10px 10px 10px;
}

.p-subtitle {
  font-size: medium;
  font-style: italic;
}

.wrapper {
  background: #f2f8fa;
  border-radius: 12px;
}

.button {
  background: #00903c;
  font-weight: 700;
  color: #fff;
  height: 48px;
  line-height: 32px;
  border-radius: 8px;
}

@media (max-width: 992px) {
  .wrapper {
    margin-bottom: 2rem;
  }
}

/* Ha a panel nyitva van */
.b-collapse.collapsing {
  background-color: #eaf4e5;
}

.modositas_icon {
  height: 20%;
  margin-right: 40px;
}

.buttonScrolling {
  width: 100%;
  background-color: white;
  color: #00903c;
  font-weight: bold;
  border: 0;
  outline: none;
  font-size: medium;
}

.when-opened svg,
.when-closed svg {
  fill: var(--color-green);
  cursor: pointer;
  margin-top: 0px;
  transition: opacity 1s ease-out;
}

.when-opened svg,
.when-closed svg {
  fill: var(--color-green);
  cursor: pointer;
  margin-top: -10px;
  transition: opacity 1s ease-out;
}

.bigButon {
  width: 100%;
  height: 120px;
  background: #00903c;
  font-weight: 700;
  color: white;
  line-height: 32px;
  border-radius: 8px;
}

.bigButon h2 {
  display: flex; /* Flexbox elrendezés, hogy egymás mellé kerüljenek az elemek */
  justify-content: space-between; /* A két span egymás mellett, széles területen */
  align-items: center; /* Vertikálisan középre igazítja az elemeket */
  width: 100%; /* Biztosítja, hogy a h2 teljes szélességben elérhető legyen */
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

.collapsed > div > div > .when-opened,
:not(.collapsed) > div > div > .when-closed {
  display: none;
}

.dsplink {
  background-color: #a27e5b;
  border-radius: 5px;
  color: white;
  font-family: Arial;
  border: none;
  cursor: pointer;
  height: 40px;
  width: auto;
}

.dspbuttonScroll {
  all: unset; /* Eltávolítja az alapértelmezett stílusokat */
  background-color: transparent; /* Alapértelmezett háttér eltávolítása */
  display: flex; /* Flexbox használata */
  align-items: center; /* Függőleges középre igazítás */
  justify-content: space-between; /* Kiegyenlíti a tartalmat a sor végére */
  width: 100%; /* A teljes szélességet kitölti */
  font-size: large;
  margin: 15px;
}

.dspbuttonScroll b-col {
  display: flex;
  align-items: center; /* Függőleges igazítás minden b-col elemnél */
}

.dspbox-Role {
  padding: 0; /* Eltávolítja a paddingot a card header-ből */
  border: none; /* Eltávolítja a szegélyeket, ha nem szükségesek */
  display: flex; /* Flexbox aktiválása a header-en belül */
  justify-content: space-between; /* Rendezi a gyermekelemeket egy sorba */
  align-items: center; /* Igazítja a tartalmat függőlegesen */
  width: 100%; /* A teljes szélességet kitölti */
  background: #4e8896;
}

.dspblockBox {
  margin: 20px;
}

.dspname,
.dsplink {
  margin: 0; /* Eltávolítja az alapértelmezett margókat */
}

.dspwhen-opened,
.dspwhen-closed {
  display: inline-block; /* Az ikonokat is sorba rendezi */
}

.dspbody {
  background: #4e8896;
  color: white;
}
.dspname {
  color: #bfe6e5;
}

::v-deep #simple-popup .modal-content {
  background-color: #f8f9fa;
  padding: 1rem;
}

::v-deep #simple-popup .modal-header {
  border-bottom: none;
  text-align: right;
}
.box-popup {
  border-radius: 20px;
  margin-top: 28%;
}
.notification-signature {
  font-weight: bold;
  text-align: right;
}

.notification-content {
  text-align: justify;
  line-height: 1.6;
}

.notification-content p {
  margin-bottom: 10px;
}
::v-deep #simple-popup .modal-content {
  background-color: #f8f9fa; /* Világos háttér */
  border-radius: 10px;
}

::v-deep #simple-popup .modal-footer {
  border-top: none;
  justify-content: center;
}
::v-deep #simple-popup .modal-header {
  border-bottom: none;
  padding: 0;
}
@media (max-width: 767px) {
  ::v-deep #simple-popup .modal-dialog {
    position: fixed;
    top: 100px;
  }
}
</style>
